import {
  afterNextRender,
  Component,
  computed,
  ElementRef,
  inject,
  output,
  signal,
  viewChild,
} from '@angular/core';
import { openGate } from '../../core/dev-gate';
import { I18nService } from '../../core/i18n-service';

/** The screen the development site shows instead of itself, until it is answered. */
@Component({
  selector: 'app-dev-gate',
  templateUrl: './dev-gate.html',
})
export class DevGate {
  private readonly i18n = inject(I18nService);
  private readonly field = viewChild.required<ElementRef<HTMLInputElement>>('field');

  readonly opened = output<void>();

  protected readonly t = computed(() => this.i18n.t().gate);
  protected readonly refused = signal(false);

  constructor() {
    // The only thing on the screen worth typing into, so it is where the cursor
    // goes. `autofocus` would say the same thing and the accessibility rules
    // refuse it.
    afterNextRender(() => this.field().nativeElement.focus());
  }

  protected try(): void {
    if (openGate(this.field().nativeElement.value)) {
      this.opened.emit();
      return;
    }
    this.refused.set(true);
    this.field().nativeElement.select();
  }
}
